 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import IDENT1 from '@/components/ident1'
 import SOMMAIRE from '@/components/sommaire'
 import PRE2 from '@/components/pre2'
 import PRE3 from '@/components/pre3'
 import P1 from '@/components/p1'
 import P1CHAP1 from '@/components/p1chap1'
 import P1CHAP2 from '@/components/p1chap2'
 import P1CHAP3 from '@/components/p1chap3'
 import P2 from '@/components/p2'
 import P2CHAP1 from '@/components/p2chap1'
 import P2CHAP2 from '@/components/p2chap2'
 import P2CHAP3 from '@/components/p2chap3'
 import P2CHAP4 from '@/components/p2chap4'
 import P2CHAP5 from '@/components/p2chap5'
 import P2CHAP6 from '@/components/p2chap6'
 import P2CHAP7 from '@/components/p2chap7'
 import P2CHAP8 from '@/components/p2chap8'
 import APPEN4 from '@/components/appen4'
 import APPEN5 from '@/components/appen5'
 import APPEN6 from '@/components/appen6'
 import APPEN7 from '@/components/appen7'
 import APPEN8 from '@/components/appen8'
 import APPEN9 from '@/components/appen9'
 import APPEN10 from '@/components/appen10'
 import IDENT11 from '@/components/ident11'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/sommaire",
 			"name" : "sommaire",
 			"component" : SOMMAIRE
 		},
 		{
 			"path" : "/pre2",
 			"name" : "pre2",
 			"component" : PRE2
 		},
 		{
 			"path" : "/pre3",
 			"name" : "pre3",
 			"component" : PRE3
 		},
 		{
 			"path" : "/p1",
 			"name" : "p1",
 			"component" : P1
 		},
 		{
 			"path" : "/p1chap1",
 			"name" : "p1chap1",
 			"component" : P1CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js